<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          <span v-if="dataAll.file_type == 1">W-8BEN</span>
          <span v-if="dataAll.file_type == 2">OTC</span>
          簽署審批
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
          <div style="padding-top: 1rem;">
            <div style="border: 1px solid #e5e5e5;">
              <div class="content-top1" style="background:#fafafa;">
                <span style="flex: 1;">證券帳號 <span style="margin-left: 10%;">{{dataAll.username}}</span></span>
                <span style="flex: 1;margin-left: 50px;">中文名稱 <span style="margin-left: 10%;">{{dataAll.realname}}</span></span>
              </div>
              <div class="content-top1" >
                <span style="flex: 1;">電郵地址 <span style="display: inline-block;width: 206px;height: 100%;
    overflow: hidden;float: right;position: relative;right: 1%;text-overflow: ellipsis;white-space: nowrap;" :title="dataAll.email">{{dataAll.email}}</span></span>
                <span style="flex: 1;margin-left: 50px;">電話號碼 <span style="margin-left: 10%;">{{dataAll.mobile}}</span></span>
              </div>
              <div class="content-top1" style="background:#fafafa;">
                <span style="flex: 1;">簽署文件 <span style="margin-left: 10%;" v-if="dataAll.file_type == 1">W-8BEN</span><span style="margin-left: 10%;" v-if="dataAll.file_type == 2">OTC</span></span>
                <span style="flex: 1;margin-left: 50px;">提交時間 <span style="margin-left: 10%;">{{dataAll.createtime}}</span></span>
              </div>
            </div>
            <div style="border: 1px solid #e5e5e5;max-height: 93px;background:#fafafa; padding: 0 20px;margin-top: 15px; overflow-y: auto;" v-if="dataAll.auditlogs.length>=1 && dataAll.file_type == 1">
              <div v-for="(item,index) in dataAll.auditlogs" :key="index">
                <div style="border-bottom:1px solid #e5e5e5; min-height: 40px;padding: 12px 0;" :class="{ 'myStyle': index === dataAll.auditlogs.length - 1 }" >
                  <span>{{item.admin}}：{{item.remark}}</span>
                  <span style="float: right;">{{item.createtime}}</span><br>
                </div>
              </div>
            </div>
            <div style="margin-top: 15px;" v-if="dataAll.file_type == 1">
              <a-textarea v-model="value2"  placeholder="請輸入備註信息" allow-clear />
            </div>
            <div style="text-align: center;margin-top: 15px;" v-if="userfileAuditAdmin">
              <button class="btnOn" @click="btnOnClick(2)">簽署失敗</button>
              <button class="btnOK" @click="btnOKClick(1)">簽署成功</button>
            </div>
          </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
export default {
  props: ["items"],
  data() {
    return {
      ishand: false,
      visible: true,
      dataAll:{},
      value2:'',
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
    };
  },
  mounted() {
    console.log(this.items, "彈窗");
    this.getUserFileMissionsDetail();
  },

  methods: {
    handleCancel(ev) {
      this.$emit("child", 0);
    },
    btnOnClick(val){
      if (this.value2 == ''&&this.dataAll.file_type == 1) {
        App.oTool.warningT('請輸入備註信息');
      }else{
        this.newUserFileAudit(val);
        this.$emit("child", 0);
      }
    },
    btnOKClick(val){
      this.value2 = "簽署成功";
      this.newUserFileAudit(val);
      this.$emit("child", 0);

    },

    getUserFileMissionsDetail() {
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/getUserFileMissionsDetail",
        url: this.$api.getUserFileMissionsDetail,
        data: {
          missionid:this.items.missionid
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    newUserFileAudit(val) {
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/newUserFileAudit",
        url: this.$api.newUserFileAudit,
        data: {
          status:val,
          remark:this.value2,
          missionid:this.items.missionid
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {

          App.oTool.successT('操作成功');
          this.$router.go(0)
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    

  },
};
</script>

<style lang="scss">
.btnOn{
  margin-right: 15%;
  background: #ed4849;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
}
.btnOK{
  background: #0c8b97;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
}
.myStyle{
  border-bottom: none !important;
}
.show-more{
  text-align: center;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
